<template>
  <div class="dashboard-default">
    <Breadcrumbs v-if="!simulatedSupplier" :title="$t('lbl_EMPBE_Home')" />
    <!-- Container-fluid starts-->
    <visitorPermission>
      <template v-slot:body>
        <b-overlay :show="loadingSponsor || loadingCompany" rounded="sm">
          <div class="col-12 dashboard-default__main">
            <EpoHomeSnackbar />
            <!-- User Management Banner - Only show for Master/Admin -->
            <div v-if="showUserManagementBanner && isMasterOrAdmin" class="user-management-banner">
              <div class="user-management-banner-content">
                <div class="user-management-banner-icon">
                  <img src="https://cdn-adsalecdn.oss-cn-shenzhen.aliyuncs.com/EMP/Backend/Images/campaign.png" alt="campaign" />
                </div>
                <div class="user-management-banner-text">
                  <div class="user-management-banner-title" v-html="$t('EMP_UserSetting_UserManagementBannerTitle')"></div>
                  <div class="user-management-banner-description">{{ $t('EMP_UserSetting_UserManagementBannerDescription') }}</div>
                </div>
                <button class="user-management-banner-button" @click="goToUserManagement">
                  {{ $t('EMP_UserSetting_UserManagementBannerButton') }}
                </button>
                <!-- <div class="user-management-banner-close" @click="closeUserManagementBanner">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L13 13M13 1L1 13" stroke="rgba(0, 0, 0, 0.60)" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                </div> -->
              </div>
            </div>
            <div class="dashboard-default__greeting">
              <div class="Roboto f-24 font-weight-bold" v-html="greetingTitle"></div>
            </div>
            <div class="mt-3 row MainRowStyle" style="align-items: stretch;">
              <div class="col-md-4 xl-50 box-col-6 MainCardStyle" >
                <SalesLead style="margin-bottom: 24px;" 
                  :UnreadEnquiry="UnreadEnquiry"
                  :UnreadNameCard="UnreadNameCard"
                  :UnreadLikeFollow="UnreadLikeFollow"
                  :UnreadSourcingRequests="UnreadSourcingRequests"
                  :UnreadSourcingContactBuyer="UnreadSourcingContactBuyer"
                  :IsFreeBooth ="IsFreeBooth"
                  :YearRemainingQuotaEnquiry="YearRemainingQuotaEnquiry"
                  :YearRemainingQuotaNameCard="YearRemainingQuotaNameCard"
                  :YearRemainingQuotaLikeFollow="YearRemainingQuotaLikeFollow"
                  :YearRemainingQuotaSourcingRequest="YearRemainingQuotaSourcingRequest"
                  :isDisabled="!!simulatedSupplier"
                />
                <div  v-if="IsShowAiPrivew">
                  <PreviewModel :id="'PreviewModelModal'" :IsMoal="false"  
                    :simulatedSupplier="simulatedSupplier"
                    v-if="showCardload " @closeAll="closeAll()"></PreviewModel>
                  <PreviewModel :id="'PreviewModelModal'" :IsMoal="true"
                    
                    :ShowMoal="true" @changedilog="changedilog()"></PreviewModel>
                </div>
                
              </div>
              <div class="col-md-4 xl-50 box-col-6 MainCardStyle">
                <eBoothSubscription :data="eBoothData" :PaymentItemData="PaymentItemData" :companyItemData="companyCompleteData"></eBoothSubscription>
              </div>
              <div class="col-md-4 xl-50 box-col-6 MainCardStyle" v-for="(item, index) in PackageData">
                <sponsorPackage :index="index" :data="item.data" :moreThanOneSponser="moreThanOneSponser">
                </sponsorPackage>
              </div>
              <div class="col-md-4 xl-50 box-col-6 MainCardStyle ">
                <aboutCPSEMP :simulatedSupplier="simulatedSupplier"></aboutCPSEMP>
              </div>
              <div class="col-md-4 xl-50 box-col-6 MainCardStyle ">
                <NewsEvents :simulatedSupplier="simulatedSupplier"></NewsEvents>
              </div>
              <div class="col-md-4 xl-50 box-col-6 MainCardStyle  CoverImg" v-if="GetDashboardCover_IsShow">
                <a :href="GetDashboardCover_Url" target="_blank"  :t_label="`EMPBE_Dashboard_Cover`">
                  <div>
                    <img :src="GetDashboardCover_Img" width="100%" />
                  </div>
                </a>
              </div>
            </div>
          </div>
        </b-overlay>
      </template>
    </visitorPermission>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import eBoothSubscription from "./Component/eBoothSubscription.vue";
import sponsorPackage from './Component/SponsorPackage';
import aboutCPSEMP from './Component/AboutCPSEMP';
import NewsEvents from './Component/NewsEvents.vue';
import { userService, adService, CompanyInfoService, InquiryFormService } from '../../_services'
import PreviewModel from "../../components/PreviewEbooth/PreviewModel.vue";
import SalesLead from "./Component/SalesLeadNotice.vue";
import EpoHomeSnackbar from "../../components/EpoHomeSnackbar.vue";
import { setItemWithExpiry, getItemWithExpiry, removeItemWithExpiry } from '../../_helpers/localStorage-utils';

function pickNonEmptyName(...values) {
  for (let i = 0; i < values.length; i += 1) {
    const v = values[i];
    if (v != null && String(v).trim() !== '') {
      return String(v).trim();
    }
  }
  return '';
}

/** 首页问候语公司名：兼容审批列表字段、PascalCase、缺繁体时回退简体/英文 */
function resolveGreetingCompanyName(user, langid) {
  const u = user || {};
  const en = pickNonEmptyName(u.companyNameEn, u.CompanyNameEn);
  const sc = pickNonEmptyName(u.companyNameSc, u.CompanyNameSc);
  const tc = pickNonEmptyName(u.companyNameTc, u.CompanyNameTc, sc);
  const id = String(langid);
  if (id === '1252') {
    return pickNonEmptyName(en, sc, tc, u.companyName, u.CompanyName);
  }
  if (id === '950') {
    return pickNonEmptyName(tc, sc, en, u.companyName, u.CompanyName);
  }
  return pickNonEmptyName(sc, tc, en, u.companyName, u.CompanyName);
}

export default {
  props: ['simulatedSupplier'],
  components: {
    eBoothSubscription,
    sponsorPackage,
    aboutCPSEMP,
    NewsEvents,
    PreviewModel,
    SalesLead,
    EpoHomeSnackbar,
  },
  data() {
    return {
      cdnURL:"https://cdn.adsalecdn.com/EMP/Backend/Images/",
      IsUAT:true,//process.env.VUE_APP_EMP_IsUat=="true"?true:false,
      eBoothGrade: '',
      eBoothExpiryDate: '',
      packageCode: '',
      packageExpiryDate: '',
      eBoothData: {},
      PackageData: [],
      PaymentItemData: [],
      loadingCompany: false,
      loadingSponsor: false,
      moreThanOneSponser: false,
      companyCompleteData: {
        percentage: 0,
        updateDate: null
      },
      showCardload:true,
      IsShowAiPrivew:true,
      UnreadEnquiry:0,
      UnreadSourcingRequests:0,
      UnreadSourcingContactBuyer:0,
      UnreadNameCard: 0,
      UnreadLikeFollow: 0,
      YearRemainingQuotaEnquiry:0,
      YearRemainingQuotaNameCard:0,
      YearRemainingQuotaLikeFollow:0,
      YearRemainingQuotaSourcingRequest:0,
      IsFreeBooth:false,
      showMigrationBanner: false,
      showUserManagementBanner: false
    }
  },
  mounted() {
    this.LoadRelatedData();
  },
  computed: {
    GetDashboardCover_IsShow()
    {
      return new Date() < new Date('2025-04-15');
    },
    GetDashboardCover_Url()
    {
      return this.langid==1252 ?  `https://www.adsalecprj.com/en/seminar/2027.html` :  `https://www.adsalecprj.com/seminar/2028.html`;
    },
    GetDashboardCover_Img()
    {
      return this.langid==1252 ?  `${this.cdnURL}dashboard_EN.jpg?x-oss-process=image/format,webp` :  `${this.cdnURL}dashboard_CN.jpg?x-oss-process=image/format,webp`;
    },
    user() {
      return this.simulatedSupplier ? this.simulatedSupplier : this.$store.state.authentication.user
    },
    isMasterOrAdmin() {
      // 业务规则：仅 Master(root) 或 Admin 可见
      // 通过判断 userRole 不等于 MEMBER 来判断是否显示
      const u = this.user || {};
      // 优先使用 userRole 字段判断
      if (u.userRole !== undefined && u.userRole !== null) {
        return u.userRole !== 'MEMBER' && u.userRole !== 'member';
      }
      // 如果没有 userRole 字段，使用 userType 作为备选方案
      return u.userType === 'ADMIN' || u.IsFullAccess === true;
    },
    langid() {
      return localStorage.getItem("currentLangId")
    },
    greetingTitle() {
      const compName = resolveGreetingCompanyName(this.user, this.langid);
      return this.$t('lbl_EMPBE_GreetingTitle').replace(
        '{Company Name}',
        "<span class='text-danger'>" + compName + "</span>",
      );
    }
  },
  created() {
    // if (this.isMobile()) {
    //   alert("Please be aware that the website is designed for PC, using mobile may not work for some functions")
    // }
  },
  watch: {
    // Watch for user data to be available before checking banner
    user: {
      handler(newUser) {
        if (newUser && newUser.empCompanyId) {
          this.checkUserManagementBanner();
        }
      },
      immediate: true
    }
  },
  methods: {
    /**
     * 获取用户管理 Banner 的过期日期（4月30日）
     * @returns {Date} 过期日期对象
     */
    getUserManagementBannerExpiryDate() {
      const now = new Date();
      const currentYear = now.getFullYear();
      return new Date(currentYear, 3, 30, 23, 59, 59); // Month is 0-indexed, so 3 = April
    },
    /**
     * 检查是否已过过期日期，如果过期则清理存储
     * @param {string} storageKey - 存储键名
     * @returns {boolean} true 表示已过期并已清理，false 表示未过期
     */
    checkAndCleanExpiredStorage(storageKey) {
      const now = new Date();
      const expiryDate = this.getUserManagementBannerExpiryDate();
      
      if (now > expiryDate) {
        removeItemWithExpiry(storageKey);
        localStorage.removeItem(storageKey);
        return true;
      }
      return false;
    },
    /**
     * 计算到过期日期的剩余时间（毫秒）
     * @returns {number} 剩余时间（毫秒）
     */
    getTimeUntilExpiry() {
      const now = new Date();
      const expiryDate = this.getUserManagementBannerExpiryDate();
      return expiryDate.getTime() - now.getTime();
    },
    /**
     * 清理旧格式的 localStorage 数据并迁移到新格式
     * @param {string} storageKey - 存储键名
     */
    migrateOldFormatToNewFormat(storageKey) {
      const oldFormatValue = localStorage.getItem(storageKey);
      if (oldFormatValue) {
        const timeUntilExpiry = this.getTimeUntilExpiry();
        setItemWithExpiry(storageKey, 'true', timeUntilExpiry);
        localStorage.removeItem(storageKey); // Remove old format
      }
    },

    closeMigrationBanner() {
      this.showMigrationBanner = false;
      // Mark as seen in localStorage for this specific user
      if (this.user && this.user.empCompanyId) {
        const storageKey = `hasSeenMigrationBanner_${this.user.empCompanyId}`;
        localStorage.setItem(storageKey, 'true');
      }
    },
    checkUserManagementBanner() {
      // Check if this specific user has seen the user management banner before
      // Only show for Master (root) or Admin accounts
      // Banner expires on April 30th - after that, remove the storage key
      if (!this.isMasterOrAdmin) return;
      if (this.user && this.user.empCompanyId) {
        const storageKey = `hasSeenUserManagementBanner_${this.user.empCompanyId}`;
        
        // If expired, clean up and return
        if (this.checkAndCleanExpiredStorage(storageKey)) {
          return;
        }
        
        // Check if user has seen the banner (using expiry-aware getter)
        const hasSeenBanner = getItemWithExpiry(storageKey);
        
        // Also check old format for backward compatibility
        const oldFormatValue = localStorage.getItem(storageKey);
        
        if (!hasSeenBanner && !oldFormatValue) {
          this.showUserManagementBanner = true;
        } else if (oldFormatValue && !hasSeenBanner) {
          // Migrate old format to new format with expiry
          this.migrateOldFormatToNewFormat(storageKey);
        }
      }
    },
    closeUserManagementBanner() {
      this.showUserManagementBanner = false;
      // Mark as seen in localStorage for this specific user with expiry
      if (this.user && this.user.empCompanyId) {
        const storageKey = `hasSeenUserManagementBanner_${this.user.empCompanyId}`;
        
        // If expired, clean up and return
        if (this.checkAndCleanExpiredStorage(storageKey)) {
          return;
        }
        
        // Set with expiry time
        const timeUntilExpiry = this.getTimeUntilExpiry();
        setItemWithExpiry(storageKey, 'true', timeUntilExpiry);
        // Also remove old format if exists
        localStorage.removeItem(storageKey);
      }
    },
    goToUserManagement() {
      // Navigate to User Management page
      this.$router.push('/UserSetting/MyUsers');
      // Close banner after navigation
      //this.closeUserManagementBanner();
    },
    changedilog(){
      this.showCardload=false;
      this.$nextTick(() => {
        this.showCardload=true;
      })
    },
    closeAll(){
      this.IsShowAiPrivew=false;
    },
    LoadRelatedData() {
      var that = this;
      this.loadingSponsor = true;
      this.loadingCompany = true;
      this.companyCompleteData.percentage = 0;
      adService.GetPackageByCompanyId({ empCompanyId: this.user.empCompanyId }).then((res => {
        if (res.isSuccessful) {
          var data = res.data;
          if (data.basicInfo) {
            that.eBoothData = data.basicInfo;
            that.PaymentItemData = data.paymentItemInfo;
          }
          if (data.packageInfo && data.packageInfo.length > 0) {
            var _item = {
              packageGroup: data.packageInfo[0].packageGroup,
              data: data.packageInfo
            }
            that.PackageData.push(_item);
          }
          if (data.sponsorshipInfo && data.sponsorshipInfo.length > 0) {
            var packageNameArr = [];
            data.sponsorshipInfo.forEach(element => {
              if (!packageNameArr.includes(element.packageGroup)) {
                packageNameArr.push(element.packageGroup);
              }
            });
            packageNameArr.forEach(element => {
              var _item = {
                packageGroup: element,
                data: data.sponsorshipInfo.filter(x => x.packageGroup == element)
              }
              that.PackageData.push(_item);
            });
          }
          that.moreThanOneSponser = that.PackageData.length > 1;
        }
      })).finally(() => {
        that.loadingSponsor = false
      })
        var parms = { companyId:  this.user.empCompanyId};
        CompanyInfoService.GetCompanyOtherInfo(parms).then((res) => {
          if (res.isSuccessful) 
          {
              if(res.data?.record?.lastSaveDate)
              {
                const [datePart, timePart] = res.data?.record?.lastSaveDate.split(' ');
                that.companyCompleteData.updateDate = `${datePart}`;
              }
              that.companyCompleteData.percentage=res.data?.progress?.progress >100 ? 100 : parseInt(res.data?.progress?.progress);

          }
        }).finally(() => {
          that.loadingCompany = false
        });
        InquiryFormService.GetUnreadNum(this.user.empCompanyId).then(res => {
          const first = res && res.length ? res[0] : {};
          this.UnreadEnquiry = first.direct ?? 0;
          this.UnreadSourcingRequests = first.sourcingRequestsNums ?? 0;
          this.UnreadSourcingContactBuyer = first.sourcingContactBuyerFormNums ?? 0;
          this.UnreadNameCard = first.nameCardNums ?? 0;
          this.UnreadLikeFollow = first.likeFollowNums ?? 0;
          this.IsFreeBooth = first.isFreeBooth ?? false;
          const totalUnread =
            this.UnreadEnquiry +
            this.UnreadNameCard +
            this.UnreadLikeFollow +
            this.UnreadSourcingRequests +
            this.UnreadSourcingContactBuyer;
          this.$store.dispatch('unread/setUnread', { unread: totalUnread, type: 'salesLead' });
        });
        
        // 分别获取立即查询和名片的剩余配额
        if (this.user?.empCompanyId) {
          const companyId = this.user.empCompanyId;
          
          // 获取立即查询配额
          InquiryFormService.GetUnlockQuotaFree({ companyId: companyId, type: 'Enquiry' })
            .then((res) => {
              const year = res?.yearUnlockQuota || res?.YearUnlockQuota;
              const remaining = year?.yearRemainingQuota || year?.YearRemainingQuota;
              this.YearRemainingQuotaEnquiry = Number(remaining || 0);
            })
            .catch(() => {
              this.YearRemainingQuotaEnquiry = 0;
            });
          
          // 获取名片配额
          InquiryFormService.GetUnlockQuotaFree({ companyId: companyId, type: 'NameCard' })
            .then((res) => {
              const year = res?.yearUnlockQuota || res?.YearUnlockQuota;
              const remaining = year?.yearRemainingQuota || year?.YearRemainingQuota;
              this.YearRemainingQuotaNameCard = Number(remaining || 0);
            })
            .catch(() => {
              this.YearRemainingQuotaNameCard = 0;
            });

          // 获取收藏配额
          InquiryFormService.GetUnlockQuotaFree({ companyId: companyId, type: 'Bookmark' })
            .then((res) => {
              const year = res?.yearUnlockQuota || res?.YearUnlockQuota;
              const remaining = year?.yearRemainingQuota || year?.YearRemainingQuota;
              this.YearRemainingQuotaLikeFollow = Number(remaining || 0);
            })
            .catch(() => {
              this.YearRemainingQuotaLikeFollow = 0;
            });

          // 获取采购需求（配对）解锁配额
          InquiryFormService.GetUnlockQuotaFree({ companyId: companyId, type: 'SourcingRequest' })
            .then((res) => {
              const year = res?.yearUnlockQuota || res?.YearUnlockQuota;
              const remaining = year?.yearRemainingQuota || year?.YearRemainingQuota;
              this.YearRemainingQuotaSourcingRequest = Number(remaining || 0);
            })
            .catch(() => {
              this.YearRemainingQuotaSourcingRequest = 0;
            });
        }
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style>
/* 去掉 Bootstrap col 两侧 15px，与横幅左右对齐 */
.dashboard-default__main {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.dashboard-default__greeting {
  width: 100%;
}

.MainRowStyle {
  margin-left: 0 !important;
  margin-right: 0 !important;
  display: flex;
  flex-wrap: wrap;
  /* 去掉卡片两侧 8px 后，用 gap 补回卡片间距 */
  gap: 16px;
}

.MainCardStyle {
  padding-left: 0 !important;
  padding-right: 0 !important;
  padding-bottom: 0 !important;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow: visible;
}

/* col-md-4 三列 + gap 16：两道缝共 32px */
@media (min-width: 768px) {
  .dashboard-default .MainRowStyle > .MainCardStyle.col-md-4 {
    flex: 0 0 calc((100% - 32px) / 3);
    max-width: calc((100% - 32px) / 3);
  }
}

/* xl-50 两列区间（1200–1660）+ gap 16：一道缝 16px */
@media screen and (max-width: 1660px) and (min-width: 1200px) {
  .dashboard-default .MainRowStyle > .MainCardStyle.xl-50 {
    flex: 0 0 calc((100% - 16px) / 2);
    max-width: calc((100% - 16px) / 2);
  }
}

/* 确保 NewsEvents 组件和 b-card 组件都能填充高度 */
.MainCardStyle .news-events,
.MainCardStyle .card {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
}
.defaultDashboard .card-header {
  padding: 40px !important;
}

.img-fluid {
  max-height: 100%;
}

.notification .card .card-header {
  padding: 40px !important;
  border-bottom: 1px solid #ecf3fa !important;
  padding-bottom: 40px !important;

}

.scroll-area {
  margin: auto;
  width: 100% !important;
  height: 617px !important;
}

.sourcingrequest-scroll-area {
  margin: auto;
  width: 100% !important;
  height: 517px !important;
}
.CoverImg img
{
  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25) !important;
  border-radius: 16px !important;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}

.migration-banner {
  width: 100%;
  margin-bottom: 16px;
}

.migration-banner-content {
  width: 100%;
  height: 100%;
  padding: 16px;
  background: linear-gradient(0deg, rgba(115, 102, 255, 0.15) 0%, rgba(115, 102, 255, 0.15) 100%), white;
  border-radius: 8px;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  display: inline-flex;
}

.migration-banner-icon {
  width: 40px;
  height: 40px;
  position: relative;
  flex-shrink: 0;
}

.migration-banner-icon img {
  width: 33.33px;
  height: 26.67px;
  position: absolute;
  left: 3.33px;
  top: 6.67px;
  object-fit: contain;
}

.migration-banner-text {
  flex: 1 1 0;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  display: inline-flex;
}

.migration-banner-title {
  align-self: stretch;
  color: rgba(0, 0, 0, 0.80);
  font-size: 16px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-weight: 600;
  line-height: 20.80px;
  word-wrap: break-word;
  margin-bottom: 4px;
}

.migration-banner-subtitle {
  align-self: stretch;
  color: rgba(0, 0, 0, 0.60);
  font-size: 14px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-weight: 400;
  line-height: 18.20px;
  word-wrap: break-word;
}

.migration-banner-close {
  width: 24px;
  height: 24px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;
}

.migration-banner-close:hover {
  opacity: 0.7;
}

.migration-banner-close img {
  width: 14px;
  height: 14px;
  object-fit: contain;
}

/* User Management Banner Styles */
.user-management-banner {
  width: 100%;
  margin-bottom: 16px;
}

.user-management-banner-content {
  width: 100%;
  height: 100%;
  padding: 16px;
  background: linear-gradient(0deg, rgba(115, 102, 255, 0.15) 0%, rgba(115, 102, 255, 0.15) 100%), white;
  border-radius: 8px;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  display: inline-flex;
}

.user-management-banner-icon {
  width: 40px;
  height: 40px;
  position: relative;
  flex-shrink: 0;
}

.user-management-banner-icon img {
  width: 33.33px;
  height: 26.67px;
  position: absolute;
  left: 3.33px;
  top: 6.67px;
  object-fit: contain;
}

.user-management-banner-text {
  flex: 1 1 0;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  display: inline-flex;
}

.user-management-banner-title {
  align-self: stretch;
  color: rgba(0, 0, 0, 0.80);
  font-size: 16px;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  line-height: 20.80px;
  word-wrap: break-word;
  margin-bottom: 4px;
}

.user-management-banner-description {
  align-self: stretch;
  color: rgba(0, 0, 0, 0.60);
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  line-height: 18.20px;
  word-wrap: break-word;
}

.user-management-banner-button {
  height: 36px;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
  overflow: hidden;
  border-radius: 4px;
  outline: 1px #7968FF solid;
  color: rgba(121, 104, 255, 1) !important;
  outline-offset: -1px;
  background: linear-gradient(0deg, rgba(115, 102, 255, 0.15) 0%, rgba(115, 102, 255, 0.15) 100%), white;
  border: none;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  display: flex;
  cursor: pointer;
  transition: all 0.2s;
  text-box-trim: trim-both;
  text-box-edge: cap alphabetic;
  text-align: center;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  line-height: 14px;
  word-wrap: break-word;
  color: rgba(0, 0, 0, 0.80);
  flex-shrink: 0;
}

.user-management-banner-button:hover {
  background: rgba(115, 102, 255, 0.05);
  outline-color: #7366FF;
}

.user-management-banner-close {
  width: 24px;
  height: 24px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;
}

.user-management-banner-close:hover {
  opacity: 0.7;
}

.user-management-banner-close svg {
  width: 14px;
  height: 14px;
}

/* 手机版隐藏 banner */
@media (max-width: 768px) {
  .user-management-banner {
    display: none !important;
  }
}
</style>
